module.exports = __webpack_public_path__ + "img/mic.caa9f8b3.jpg";